import { bindActionCreators } from 'redux'
import * as Actions from 'src/redux/actions'
import { useDispatch, useMemo } from './'

const useActions = () => {
  const dispatch = useDispatch()
  return useMemo(() => bindActionCreators(Actions, dispatch), [dispatch])
}

export default useActions
